import { FC, useContext, useEffect, useRef, useState } from 'react';

import { H3, NumberInput } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { SettingsLock } from '../SettingsLock';
import { ITimeOutInputProps } from './interfaces';
import s from './TimeOutInput.module.scss';

export const TimeOutInput: FC<ITimeOutInputProps> = ({
  setting,
  updateSetting,
  settingAlias,
  label,
  inMinutes,
  maxMinutes,
  minMinutes = 1,
  disabled,
  description,
  isAvailable,
  zero,
}) => {
  const { t } = useContext(LocalizationContext);

  const ref = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState<number | ''>(setting);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    setInputValue(setting);
  }, [setting]);

  return (
    <div className={s.container}>
      <div className={s.header}>
        {isAvailable === undefined ? (
          <>
            <H3 className={s.label}>{label}</H3>
            {description && (
              <span className={s.description}>{description}</span>
            )}
          </>
        ) : (
          <>
            <div className={s.header_lock}>
              <H3 className={s.label}>{label}</H3>
              {!isAvailable && <SettingsLock />}
            </div>
            {description && (
              <span className={s.description}>{description}</span>
            )}
          </>
        )}
      </div>
      <div className={s['timeout']}>
        <NumberInput
          ref={ref}
          variant="secondary"
          error={error}
          value={inputValue}
          onChange={setInputValue}
          onEnter={() => ref.current?.blur()}
          onBlur={() => {
            if (zero && inputValue < minMinutes) {
              setError(
                t('errors.min', String(minMinutes), t('contracted.minutes'))
              );
              return;
            }

            if ((!inputValue || inputValue < minMinutes) && !zero) {
              setError(t('errors.min', minMinutes, t('contracted.minutes')));
              return;
            }

            if (maxMinutes && inputValue > maxMinutes) {
              setError(t('errors.max', maxMinutes, t('contracted.minutes')));
              return;
            } else {
              setError(undefined);
            }

            if (inputValue !== setting) {
              updateSetting({
                alias: settingAlias,
                value: JSON.stringify(
                  inMinutes ? Number(inputValue) * 60 : inputValue
                ),
              });
            }
            if (zero && inputValue == 0) {
              setInputValue(0);
            }
          }}
          rightContent={t('contracted.minutes')}
          disabled={disabled !== undefined ? !disabled : false}
          bordered
        />
      </div>
    </div>
  );
};
